module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-95d2c462.svg";